<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      size="lg"
      id="edit_modal"
      ref="modal"
      title="Your Mobile Phone Number"
      :busy="loading"
    >
      <b-form class="form" @submit.prevent="passes(doSubmit)">
        <p class="text-danger" v-if="errors.phone">
          {{ errors.phone[0] }}
        </p>

        <validation-provider
          name="phone"
          rules="required|min:9"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <vue-tel-input
              @validate="validatePhone($event)"
              v-model="phone"
            ></vue-tel-input>
          </div>

          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </b-form>

      <template v-slot:modal-footer>
        <b-button
          variant="info"
          type="submit"
          @click="doSubmit"
          :disabled="invalid || loading || !onLine"
        >
          Save Changes
        </b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapState } from "vuex";
import { DISPATCH_ADD_PHONE } from "@/store/action-types";

import { VueTelInput } from "vue-tel-input";
require("vue-tel-input/dist-modern/vue-tel-input.css");

export default {
  name: "AddPhoneModal",

  components: {
    ValidationObserver,
    ValidationProvider,
    VueTelInput,
  },

  data() {
    return {
      phone: "",
      invalid: true,
      form: {
        phone: "",
        country: "",
      },
    };
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),
  },


  methods: {
    create() {
      this.$refs.modal.show();
    },

    validatePhone(e) {
     // console.log(e);
      if (e.valid === true) {
        this.form.phone = e.number;
        this.form.country = e.country.name.split(" ")[0];
        this.invalid = false;
      } else {
        this.form.phone = "";
        this.invalid = true;
}
    },

    doSubmit() {

      if (this.invalid) {
        this.$refs.observer.setErrors({ phone: ["Invalid Phone Number"] });
        return;
      }

      this.$store
        .dispatch(DISPATCH_ADD_PHONE, this.form)
        .then(() => {
          this.$refs.modal.hide();
        })
        .catch(() => {
          this.$refs.observer.setErrors(this.errors);
        });
    },
  },
};
</script>